import React, { useEffect, useState, useContext, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { CardWIP } from "../../../components/CardWIP";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useHistory } from "react-router-dom";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Multiselect } from 'multiselect-react-dropdown';
import { CardWipTotal } from "../../../components/CardWipTotal";
import { getClients } from '../../../services/clientes';
import { getPeritos } from '../../../services/peritos';
import { getDisciplinas } from '../../../services/disciplinas';
import { getUrlParams } from '../../../utils/getUrlParams'
import Swal from "sweetalert2";
import { IconRefresh } from "../../../svg";

export const WIP = () => {
    const [WIPData, setWIPData] = useState(null);
    const [WIPDataCRT, setWIPDataCRT] = useState(null);
    const [WIPDataTodos, setWIPDataTodos] = useState(null);
    const { register, handleSubmit, reset } = useForm();
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [idDisciplinas, setDisciplinasId] = useState([]);
    var [idLideres, setIdLideres] = useState([]);
    var [idPeritos, setPeritosId] = useState([]);
    var [peritosText, setPeritosText] = useState(null);
    var [idClientes, setIdClientes] = useState([]);
    const [disciplinaList, setDisciplinaList] = useState([]);
    const [disciplinaListSelected, setDisciplinaListSelected] = useState([]);
    const [peritosList, setPeritosList] = useState([]);
    const [liderSelected, setLiderSelected] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [clientListSelected, setClientListSelected] = useState([]);
    const multiselectRefSeg = useRef();
    const multiselectRefDis = useRef();
    const multiselectRefLi = useRef();
    const submitButtonRef = useRef(null)
    var [isLoading, setisLoading] = useState(true);
    var [isLoadingPesquisa, setisLoadingPesquisa] = useState(true);
    const [searchedParams, setSearchedParams] = useState("");
    const urlParams = new URLSearchParams(window.location.search);
    const tabIndexFromUrl = urlParams.get('tabIndex');
    const [pesquisaAvancada, setPesquisaAvancada] = useState(urlParams.get('pesquisaAvancada') == 'true');
    var [empresasUser, setEmpresasUser] = useState([]);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);

    const getLista = async (formValues = null, IdEmpresa) => {
        let list = null;

        let params = `IdEmpresa=${IdEmpresa}`;
        let detalhadaParams = ""

        if (formValues != null) {
            if (formValues.Sigla.length > 0) {
                detalhadaParams += `&Sigla=${formValues.Sigla}`;
                params += `&Sigla=${formValues.Sigla}`;
            }

            if (formValues?.Segurado != null && formValues?.Segurado !== undefined && formValues?.Segurado.length > 0) {
                detalhadaParams += `&Segurado=${formValues.Segurado}`;
                params += `&Segurado=${formValues.Segurado}`;
            }

            if (formValues?.Analista != null && formValues?.Analista !== undefined && formValues?.Analista.length > 0) {
                detalhadaParams += `&Analista=${formValues.Analista}`;
                params += `&Analista=${formValues.Analista}`;
            }

            if (formValues.idPeritos.length > 0) {
                formValues.idPeritos.forEach(perito => {
                    detalhadaParams += `&IdPeritos=${perito}`;
                    params += `&IdPeritos=${perito}`;
                });
            }

            if (formValues.idDisciplinas.length > 0) {
                formValues.idDisciplinas.forEach(disciplina => {
                    detalhadaParams += `&IdDisciplinas=${disciplina}`;
                    params += `&IdDisciplinas=${disciplina}`;
                });
            }

            if (formValues.idLideres.length > 0) {
                formValues.idLideres.forEach(lider => {
                    detalhadaParams += `&IdLideres=${lider}`;
                    params += `&IdLideres=${lider}`;
                });
            }

            if (formValues.idClientes.length > 0) {
                formValues.idClientes.forEach(cliente => {
                    detalhadaParams += `&IdClientes=${cliente}`;
                    params += `&IdClientes=${cliente}`;
                });
            }
        }

        detalhadaParams += `&pesquisaAvancada=${pesquisaAvancada}`;

        setSearchedParams(detalhadaParams)
        try {
            const response = await api.get(`WIP?${params}`);
            list = response.data;
            return list;
        } catch (error) {
            if (IdEmpresa === 0) {
                registrationFailure(error?.response?.data?.notification?.messageReturn)

            }
            return list;
        }
    }

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    const advanceSearch = {
        name: 'advanceSeach',
        label: 'Pesquisa Avançada',
        id: 'advanceSeach',
        status: pesquisaAvancada,
        checked: pesquisaAvancada
    };

    const formSubmit = async (data) => {
        if (data) {
            data.idPeritos = idPeritos;
            data.idDisciplinas = idDisciplinas;
            data.idLideres = idLideres;
            data.idClientes = idClientes;
        }
        setisLoadingPesquisa(true);
        formData(data);
    }

    const removeFaturado = (data) => {
        return data.map(item => {
            if (item?.data.length > 0) {
                item.data = item?.data.filter(item => item.key !== 'Faturado' && item.key !== 'Cancelada');
            }

            return item;
        });
    };

    const formData = async (data) => {
        Promise.all([getLista(data, 0), getLista(data, 1), getLista(data, 2)]).then((values) => {
            // remover faturados
            values = removeFaturado(values);

            setWIPDataTodos(values[0]);
            setWIPData(values[1]);
            setWIPDataCRT(values[2]);
            setisLoading(false);
            setisLoadingPesquisa(false);
        });
    };

    const getCardId = (id) => {
        let cardId = document.getElementById(id);
        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    const onGetCliente = (currentValue, value) => {
        let clienteList = [];
        currentValue.map(a => { clienteList.push(a.idCliente) });
        setIdClientes(clienteList);
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];
        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        setDisciplinasId(disciplinasList);
    };

    const onGetPerito = (perito, value) => {
        if (value === "clear" || value === null) {
            setPeritosText(null);
            setPeritosId([]);
            return;
        }

        var porteSinistroResult = peritosList.filter(function (o) {
            return o.id == value;
        });

        idPeritos = [porteSinistroResult[0].id];
        peritosText = porteSinistroResult[0].label;
        setPeritosText(peritosText);
        setPeritosId(idPeritos);

    };

    const onGetLider = (currentValue, value) => {
        let list = [];
        currentValue.map(a => { list.push(a.value) });
        setIdLideres(list);
    };

    const onRemoveDisciplina = (currentValue, value) => {
        onGetDisciplina(currentValue)
    }

    const onRemovePerito = (currentValue, value) => {
        onGetPerito(currentValue)
    }


    const onRemoveLider = (currentValue, value) => {
        onGetLider(currentValue)
    }

    const onRemoveCliente = (currentValue, value) => {
        onGetCliente(currentValue)
    }

    const resetFormAvancado = () => {
        reset({
            Sigla: '',
            Segurado: '',
            Analista: ''
        });

        setPeritosId([]);
        setIdLideres([]);
        setDisciplinasId([]);
        setIdClientes([]);
        onGetPerito("", "clear")

        multiselectRefSeg.current.resetSelectedValues();
        multiselectRefDis.current.resetSelectedValues();
        multiselectRefLi.current.resetSelectedValues();

        window.history.replaceState(null, '', window.location.pathname);
        formSubmit(null);
    }

    const getStatusToggle = (status) => {
        setPesquisaAvancada(status)
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                var selectedClientes = []

                clients.map(cliente => {
                    if (getUrlParams("IdClientes").indexOf(cliente.idCliente.toString()) > -1) {
                        selectedClientes.push(cliente)
                    }
                })
                setClientList(clients);
                onGetCliente(selectedClientes, "");
                setClientListSelected(selectedClientes);
            }

            const disciplinas = await getDisciplinas();
            if (!!disciplinas) {
                var selectedDisciplinas = []

                disciplinas.map(disciplina => {
                    if (getUrlParams("IdDisciplinas").indexOf(disciplina.idDisciplina.toString()) > -1) {
                        selectedDisciplinas.push(disciplina)
                    }
                })
                setDisciplinaList(disciplinas);
                onGetDisciplina(selectedDisciplinas, "");
                setDisciplinaListSelected(selectedDisciplinas);
            }

            const peritos = await getPeritos();
            if (!!peritos) {
                const peritosFormatados = []
                peritos.map(perito => {
                    var item = {
                        "value": perito.idUsuario,
                        "id": perito.idUsuario,
                        "label": perito.nome
                    };
                    peritosFormatados.push(item);
                });
                setPeritosList(peritosFormatados);

                var selectedLideres = []
                peritosFormatados.map(perito => {
                    if (getUrlParams("IdLideres").indexOf(perito.value.toString()) > -1) {
                        selectedLideres.push(perito)
                    }

                    if (getUrlParams("IdPeritos").indexOf(perito.value.toString()) > -1) {
                        idPeritos = [perito.id];
                        peritosText = perito.label;
                        setPeritosText(peritosText);
                        setPeritosId(idPeritos);
                    }
                })
                onGetLider(selectedLideres)
                setLiderSelected(selectedLideres)
            }

            reset({
                Sigla: getUrlParams("Sigla"),
                Segurado: getUrlParams("Segurado"),
                Analista: getUrlParams("Analista")
            });
        }

        asyncFn().then((values) => {
            var formValues = {
                Sigla: getUrlParams("Sigla"),
                Segurado: getUrlParams("Segurado"),
                Analista: getUrlParams("Analista"),
                idPeritos: getUrlParams("IdPeritos"),
                idDisciplinas: getUrlParams("IdDisciplinas"),
                idLideres: getUrlParams("IdLideres"),
                idClientes: getUrlParams("IdClientes")
            }
            formData(formValues);
            if (urlParams.get('pesquisaAvancada') == 'true') {
                getStatusToggle(true)
            }

        })
    }, [null, 0, 10]);


    useEffect(() => {
        checkIsMultEmpresaUser();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const index = params.get("tabIndex");
        if (index !== null) {
            setIdEmpresaIndexTab(parseInt(index));
        }
    }, [window.location.search]);

    const checkIsMultEmpresaUser = (value) => {

        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];



        if (empresas) {
            empresasUser = empresas;
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            idEmpresaIndexTab = 0;
            setIdEmpresaIndexTab(idEmpresaIndexTab);
        } else {
            switch (empresasUser[0]) {
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;

            }
        }


    }



    const refreshData = async () => {
        var formValues = {
            Sigla: getUrlParams("Sigla"),
            Segurado: getUrlParams("Segurado"),
            Analista: getUrlParams("Analista"),
            idPeritos: getUrlParams("IdPeritos"),
            idDisciplinas: getUrlParams("IdDisciplinas"),
            idLideres: getUrlParams("IdLideres"),
            idClientes: getUrlParams("IdClientes")
        }
        setisLoadingPesquisa(true);
        formData(formValues);

    };


    const filtroEmpresa = (currentValue, indexTab) => {
        setIdEmpresaIndexTab(indexTab);
        const params = new URLSearchParams(window.location.search);
        params.set("tabIndex", indexTab);
        window.history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
    };
    
    const history = useHistory();

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">WIP</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="row">
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                <ToggleSwitch config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                            </div>
                        </div>

                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container mt-4` : `form-wrapper filter-container filter-hide`}>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-4 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Analista'} name={'Analista'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Seguradoras'}
                                        showCheckbox="true"
                                        options={clientList}
                                        selectedValues={clientListSelected} // Preselected value to persist in dropdown
                                        onSelect={onGetCliente}
                                        onRemove={onRemoveCliente}
                                        displayValue="cliente"
                                        ref={multiselectRefSeg}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Disciplinas'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        selectedValues={disciplinaListSelected} // Preselected value to persist in dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        ref={multiselectRefDis}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Lider'}
                                        showCheckbox="true"
                                        options={peritosList} // Options to display in the dropdown
                                        selectedValues={liderSelected} // Preselected value to persist in dropdown
                                        onSelect={onGetLider} // Function will trigger on select event
                                        onRemove={onRemoveLider} // Function will trigger on remove event
                                        displayValue="label" // Property name to display in the dropdown options
                                        ref={multiselectRefLi}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    {<DynamicSelect placeholder={''}
                                        valuetext={peritosText}
                                        label={'Profissionais'}
                                        name={'idPeritos'}
                                        options={peritosList}
                                        keyValue={'value'}
                                        keyLabel={'label'}
                                        paramMethod={onGetPerito}
                                        clearOption={true} />}
                                </div>
                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <input className='default-button' value='Limpar' type="button" onClick={resetFormAvancado} />

                                    <input type="submit" className='default-button-red ml-3' value='Pesquisar' ref={submitButtonRef} />

                                </div>
                            </div>
                        </StyledForm>
                        <br />
                        {isLoading || isLoadingPesquisa ? <StldRow>
                            <div className="text-center">
                                <div className="align-items-center">
                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                    <div><strong style={{ color: "#EE4B21" }}>{isLoading ? 'Carregando...' : 'Pesquisando...'}</strong></div>
                                </div>
                            </div>
                        </StldRow> : (

                            <Tabs className="timesheet m-0" selectedIndex={idEmpresaIndexTab}>
                                {empresasUser?.length > 1 ? <TabList>
                                    <Tab onClick={() => filtroEmpresa(1, 0)}>Critério Experts</Tab>
                                    <Tab onClick={() => filtroEmpresa(2, 1)}>Adjusters</Tab>
                                    <Tab onClick={() => filtroEmpresa("all", 2)}>Todos</Tab>
                                </TabList> : ''}
                                <TabPanel>
                                    <StldRow>
                                        {
                                            WIPData != null && WIPData.data.length > 0 && (
                                                <StldColumn key={'A00'} xs="12" sm="6" md="4" lg="4" xl="4">
                                                    <CardWipTotal
                                                        data={WIPData?.data} f
                                                        title={"Total Critério Experts"}
                                                        history={history}
                                                        empresa={1}
                                                        params={searchedParams}
                                                    >
                                                    </CardWipTotal>
                                                </StldColumn>
                                            )
                                        }
                                        {
                                            WIPData != null && WIPData.data.length > 0 ? (
                                                WIPData.data.map((item, index) => {
                                                    return (
                                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                                            <CardWIP
                                                                params={searchedParams}
                                                                item={item}
                                                                isFromPerito={idPeritos?.length > 0}
                                                                getCardId={getCardId}
                                                                history={history}
                                                                indexTab={idEmpresaIndexTab}
                                                                empresa={1} />
                                                        </StldColumn>
                                                    )
                                                })
                                            ) : (
                                                <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado para Critério Experts!
                                                    </div>
                                                </StldColumn>)
                                        }
                                    </StldRow>
                                </TabPanel>
                                <TabPanel>
                                    <StldRow>
                                        {
                                            WIPDataCRT != null && WIPDataCRT.data.length > 0 && (
                                                <StldColumn key={'A01'} xs="12" sm="6" md="4" lg="4" xl="4">
                                                    <CardWipTotal
                                                        data={WIPDataCRT?.data}
                                                        title={'Total Adjusters'}
                                                        history={history}
                                                        empresa={2}
                                                        params={searchedParams}
                                                    >
                                                    </CardWipTotal>
                                                </StldColumn>
                                            )
                                        }
                                        {
                                            WIPDataCRT != null && WIPDataCRT.data.length > 0 ? (
                                                WIPDataCRT.data.map((item, index) => {
                                                    return (
                                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                                            <CardWIP
                                                                params={searchedParams}
                                                                item={item}
                                                                isFromPerito={idPeritos.length > 0}
                                                                getCardId={getCardId}
                                                                history={history}
                                                                indexTab={idEmpresaIndexTab}
                                                                empresa={2} />
                                                        </StldColumn>
                                                    )
                                                })
                                            ) : (
                                                <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado para Adjusters!
                                                    </div>
                                                </StldColumn>)
                                        }
                                    </StldRow>
                                </TabPanel>
                                <TabPanel>
                                    <StldRow>

                                        {
                                            WIPDataTodos != null && WIPDataTodos.data.length > 0 && (
                                                <StldColumn key={'A02'} xs="12" sm="6" md="4" lg="4" xl="4">
                                                    <CardWipTotal
                                                        data={WIPDataTodos?.data}
                                                        title={'Total Geral'}
                                                        history={history}
                                                        empresa={0}
                                                        params={searchedParams}
                                                    >
                                                    </CardWipTotal>
                                                </StldColumn>
                                            )
                                        }
                                        {
                                            WIPDataTodos != null && WIPDataTodos.data.length > 0 ? (
                                                WIPDataTodos.data.map((item, index) => {
                                                    return (
                                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                                            <CardWIP
                                                                params={searchedParams}
                                                                item={item}
                                                                isFromPerito={idPeritos.length > 0}
                                                                getCardId={getCardId}
                                                                history={history}
                                                                indexTab={idEmpresaIndexTab}
                                                                empresa={0} />
                                                        </StldColumn>
                                                    )
                                                })
                                            ) : (
                                                <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado!
                                                    </div>
                                                </StldColumn>)
                                        }
                                    </StldRow>
                                </TabPanel>
                            </Tabs>
                        )
                        }
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const WIPPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <WIP />

                </>
            )}
        </>
    );
};